import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { logRavenException } from './errors';
const createOwnedProductString = parsedProducts => {
  const translatedProducts = [];
  for (const product of parsedProducts) {
    const productLanguageKey = `upgrades.products.${product}`;
    if (isValidI18nKey(productLanguageKey)) {
      translatedProducts.push(I18n.text(productLanguageKey));
    }
  }
  return translatedProducts.join(', ');
};
const SELECTABLE_SEAT_TYPES = ['core', 'sales', 'service', 'commerce'];
export const getSeatSelectOptions = (seatInfoResponse, ownedProductsThatRequireCoreSeat) => {
  const seatSelectOptions = [];
  for (const seatInfo of seatInfoResponse) {
    const [seatType, tier] = seatInfo.seatName.split('-');
    if (seatInfo.maxAssignableSeats && seatInfo.maxAssignableSeats > 0 && SELECTABLE_SEAT_TYPES.includes(seatType)) {
      const seatTypeTitleKey = `upgrades.requestSeatModal.seatInputSelect.${seatType}.title`;
      let seatTypeSubtitleKey = '';
      if (seatType === 'core' && ownedProductsThatRequireCoreSeat.length === 0) {
        seatTypeSubtitleKey = `upgrades.requestSeatModal.seatInputSelect.core.fallbackSubtitle`;
      } else {
        seatTypeSubtitleKey = `upgrades.requestSeatModal.seatInputSelect.${seatType}.subtitle`;
      }
      const seatLevelKey = `upgrades.productCatalog.tableHeader.${tier === 'pro' ? 'professional' : tier}`;
      if (isValidI18nKey(seatTypeTitleKey) && isValidI18nKey(seatTypeSubtitleKey)) {
        seatSelectOptions.push({
          text: I18n.text(seatTypeTitleKey),
          value: seatInfo.seatName,
          help: I18n.text(seatTypeSubtitleKey, {
            ownedProductsThatRequireCoreSeat: createOwnedProductString(ownedProductsThatRequireCoreSeat),
            seatLevel: isValidI18nKey(seatLevelKey) ? I18n.text(seatLevelKey) : ''
          })
        });
      } else {
        const errorMessage = `getSeatSelectOptions: invalid I18n key for ${seatTypeTitleKey}`;
        logRavenException({
          customMessage: errorMessage,
          error: Error(errorMessage),
          seatType,
          tier,
          fingerprint: ['getSeatSelectOptions']
        });
      }
    }
  }
  return seatSelectOptions.sort((a, b) => {
    if (a.text > b.text) {
      return -1;
    } else if (b.text < a.text) {
      return 1;
    } else {
      return 0;
    }
  }).reverse();
};